import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';;
import { Candidate } from '../../../core/models';
import { errorTranslations } from '../../../../utils/constants';
import { StorageService } from '../../../core/services';

@Component({
  selector: 'app-candidate-pubsubqueues-modal',
  templateUrl: './candidate-pubsubqueues-modal.component.html',
  styleUrls: ['./candidate-pubsubqueues-modal.component.scss']
})

export class CandidatePubsubqueuesComponent implements OnInit {
  @Input() candidate: Candidate;

  public itemsPerPage: number = 5;
  public currentPage: number = 1;
  public loading: boolean = true;
  public error: boolean = false;


  constructor(
    private activeModal: NgbActiveModal,
    private storageService: StorageService
  ) { }

  user = this.storageService.getUser();

  get pubsubqueues(): any[] {
    return (this.candidate && (this.candidate as any).pubsubqueues) || [];
  }

  ngOnInit() {
    this.loading = false;
  }

  public closeModal(): void {
    this.activeModal.close();
  }

  public translate(reason: string): string {
    if (!reason) return 'Integração em andamento';

    const key = reason.trim().toLowerCase();
    const translated = errorTranslations[key];

    if (translated) {
      return translated;
    }

    let text = reason.replace(/\\n/g, '\n');

    if (!text.includes('{')) {
      return this.replaceDotInLargeWords(text.trim());
    }

    const lines: string[] = [];

    const jsonStart = text.indexOf('{');
    if (jsonStart > 0) {
      lines.push(text.substring(0, jsonStart).trim());
    }

    const brRegex = /"br"\s*:\s*"([^"]*)"/g;
    let match;

    while ((match = brRegex.exec(text)) !== null) {
      lines.push(match[1]);
    }

    const textRegex = /"#text"\s*:\s*"([^"]*)"/g;
    while ((match = textRegex.exec(text)) !== null) {
      lines.push(match[1]);
    }

    if (lines.length === 0) {
      return text.trim();
    }

    return this.replaceDotInLargeWords(
      lines
        .join('\n')
        .replace(/\n{2,}/g, '\n')
        .trim()
    );
  }

  private replaceDotInLargeWords(text: string, maxLength = 20): string {
    return text
      .split(' ')
      .map(word => {
        if (word.length > maxLength && word.includes('.')) {
          return word.replace(/\./g, ' ');
        }
        return word;
      })
      .join(' ');
  }

  public downloadTrace(item: any): void {
    if (!item || !item.trace) {
      return;
    }

    const json = JSON.stringify(item.trace, null, 2);

    const blob = new Blob([json], {
      type: 'application/json;charset=utf-8'
    });

    const url = window.URL.createObjectURL(blob);

    const date = new Date(item.endTime);

    const dataHora =
      date.getFullYear() +
      '-' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + date.getDate()).slice(-2) +
      '_' +
      ('0' + date.getHours()).slice(-2) +
      '-' +
      ('0' + date.getMinutes()).slice(-2);

    const nome = (item.client || 'integracao')
      .toString()
      .trim()
      .replace(/[\\/:*?"<>|]/g, '_')
      .replace(/\s+/g, '_');

    const a = document.createElement('a');
    a.href = url;
    a.download = `log_integracao_${nome}_${dataHora}.json`;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    window.URL.revokeObjectURL(url);
  }

}